import React, { useRef } from 'react'
import { motion, useInView } from 'framer-motion'

interface AnimatedHeaderProps {
  children: React.ReactNode
  className?: string
  style?: React.CSSProperties
  delay?: number
}

export const AnimatedHeader: React.FC<AnimatedHeaderProps> = ({ 
  children, 
  className = '', 
  style = {},
  delay = 0 
}) => {
  const ref = useRef(null)
  const isInView = useInView(ref, { once: false, amount: 0.5 })

  // Detect prefers-reduced-motion
  const prefersReducedMotion = useRef(
    typeof window !== 'undefined' 
      ? window.matchMedia('(prefers-reduced-motion: reduce)').matches 
      : false
  )

  return (
    <motion.div
      ref={ref}
      initial={prefersReducedMotion.current ? { opacity: 1, y: 0 } : { opacity: 0, y: 30 }}
      animate={isInView ? { opacity: 1, y: 0 } : {}}
      transition={{
        duration: 0.8,
        delay,
        ease: [0.4, 0.0, 0.2, 1]
      }}
      className={className}
      style={style}
    >
      {children}
    </motion.div>
  )
}
